import { render, staticRenderFns } from "./JobPostForApplicant.vue?vue&type=template&id=cb712de0&scoped=true&"
import script from "./JobPostForApplicant.vue?vue&type=script&lang=js&"
export * from "./JobPostForApplicant.vue?vue&type=script&lang=js&"
import style0 from "./JobPostForApplicant.vue?vue&type=style&index=0&id=cb712de0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb712de0",
  null
  
)

export default component.exports